import React, { useState, useEffect } from "react";
import grapesjs from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import mjmlPlugin from "grapesjs-mjml";
import { useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import Sidebar from "./Sidemenu";
import mjml2html from "mjml-browser";

const ProductItem = ({
  product,
  selectedProductIds,
  selectedVariantIds,
  onProductSelect,
  onVariantSelect,
}) => {
  // Filter out the default variant with a title like "Default Title" if necessary
  const displayedVariants = product.variants.filter(
    (variant) => variant.title.toLowerCase() !== "default title"
  );

  return (
    <div
      style={{
        padding: "10px",
        borderBottom: "1px solid #eee",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: displayedVariants.length > 0 ? "10px" : "0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            style={{ marginRight: "10px" }}
            checked={selectedProductIds.includes(product.id)}
            onChange={(e) => onProductSelect(product, e.target.checked)}
          />
          <img
            src={product.images[0]?.src}
            alt={product.title}
            style={{
              width: "50px",
              height: "50px",
              marginRight: "10px",
            }}
            className="img-thumbnail"
          />
          <strong>{product.title}</strong>
        </div>
        <strong style={{ marginLeft: "auto" }}>
          ₹{product.variants[0]?.price || "0.00"}
        </strong>
      </div>

      {displayedVariants.length > 0 &&
        displayedVariants.map((variant) => (
          <div
            key={variant.id}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "5px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <input
                type="checkbox"
                style={{ marginLeft: "20px" }}
                checked={selectedVariantIds.includes(variant.id)}
                onChange={(e) =>
                  onVariantSelect(product, variant.id, e.target.checked)
                }
              />
              <span style={{ color: "#666", fontSize: "0.9em" }}>
                {variant.title}
              </span>
            </div>
            <span
              style={{ marginLeft: "auto", color: "#666", fontSize: "0.9em" }}
            >
              ₹{variant.price}
            </span>
          </div>
        ))}
    </div>
  );
};

function Frontendapp() {
  const backendUrl = "https://popupdev.epic-x.io";
  const [editor, setEditor] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [templateNames, setTemplateNames] = useState([]);
  const [currentTemplateName, setCurrentTemplateName] = useState("");
  const [currentTemplateContent, setCurrentTemplateContent] = useState("");
  const [emailPopupVisible, setEmailPopupVisible] = useState(false);
  const [displayText, setDisplayText] = useState("");
  const [linkType, setLinkType] = useState("");
  const [linkURL, setLinkURL] = useState("");
  const templateContentFromTheme = useLocation().state?.templateContent;
  const templateName = useLocation().state?.templateName;
  const [lastSelectedComponent, setLastSelectedComponent] = useState(null);

  const [domain, setDomain] = useState("");
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [selectedVariantIds, setSelectedVariantIds] = useState([]);
  const [viewProduct, SetViewProduct] = useState(false);
  const [products, setProducts] = useState([]);
  const displayTextUrlMap = {};

  const fetchTemplateContent = async (templateName) => {
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_BACKEND_URL
        }/templateContent/${encodeURIComponent(templateName)}`
      );

      if (!response.ok) {
        throw new Error(
          `Failed to fetch template content. Status: ${response.status}`
        );
      }

      const data = await response.json();

      if (data.success) {
        setCurrentTemplateName(templateName);
        setCurrentTemplateContent(data.templateContent);
      } else {
        console.error("Error fetching template content:", data.error);
      }
    } catch (error) {
      console.error("Error fetching template content:", error.message);
    }
  };

  const handleLinkButtonClick = () => {
    setEmailPopupVisible(true);
    if (
      lastSelectedComponent &&
      lastSelectedComponent.get("type") === "mj-image"
    ) {
      setLinkType("image");
    }
  };

  const handleEmailPopupSubmit = (e) => {
    e.preventDefault();

    if (lastSelectedComponent) {
      const text = displayText.trim();
      const url = linkURL.trim();
      console.log("URL", url, linkURL);

      if (lastSelectedComponent.get("type") === "mj-text") {
        lastSelectedComponent.setAttributes({
          href: url,
          "data-link-type": linkType,
        });

        lastSelectedComponent.set(
          "content",
          `<a href="${url}" target="_blank">${text}</a>`
        );
      } else if (lastSelectedComponent.get("type") === "mj-button") {
        lastSelectedComponent.setAttributes({
          href: url,
          "data-link-type": linkType,
        });
        lastSelectedComponent.set(
          "content",
          `<mj-button href="${url}" background-color="#48b6bf" color="white">${text}</mj-button>`
        );
      } else if (lastSelectedComponent.get("type") === "mj-image") {
        lastSelectedComponent.setAttributes({
          href: url,
          "data-link-type": linkType,
        });
        lastSelectedComponent.set(
          "content",
          `<a href="${url}" target="_blank"></a>`
        );
      } else if (lastSelectedComponent.get("type") === "mj-navbar-link") {
        // Clear any existing attributes related to href, target, and data-link-type
        lastSelectedComponent.removeAttributes(["href"]);

        // Now set the new attributes
        lastSelectedComponent.setAttributes({
          href: url, // Make sure this is a valid absolute URL
          "data-link-type": linkType,
          target: "_blank",
        });

        // Set only the text content or plain HTML as the content
        lastSelectedComponent.set("content", text);
      } else if (lastSelectedComponent.get("type") === "mj-social-element") {
        const url = linkURL.trim();

        lastSelectedComponent.setAttributes({
          href: url,
          "data-link-type": linkType,
        });

        // Set the entered URL as content for the mj-social-element
        lastSelectedComponent.set(
          `<mj-social-element>${url}</mj-social-element>`
        );
      }

      const finalHtml = lastSelectedComponent.toHTML();
      console.log("Final HTML:", finalHtml);

      displayTextUrlMap[displayText] = linkURL;

      setLastSelectedComponent(null);
      resetEmailForm();
      setEmailPopupVisible(false);
    }
  };

  const resetEmailForm = () => {
    setDisplayText("");
    setLinkType("");
    setLinkURL("");
  };

  const handleCanvasClick = (event) => {
    const { editor } = window;
    const clickedElement = event.target;

    const clickedText = displayText;
    const clickedURL = displayTextUrlMap[clickedText];

    if (clickedURL) {
      window.open(clickedURL, "_blank");
    }
  };

  const handleViewProductSubmit = () => {
    // Assuming selectedProduct contains the product object with image, title, price, and buy link
    const selectedProduct = products.find((product) =>
      selectedProductIds.includes(product.id)
    );

    if (selectedProduct) {
      // Update GrapesJS editor
      editor.setComponents(`
       <mjml>
  <mj-body>
    <mj-section>
      <mj-column>
        <mj-image src="${selectedProduct.image.src}" alt="${selectedProduct.title}" href="https://${domain}/products/${selectedProduct.title}"  />
      </mj-column>
      <mj-column>
        <mj-text font-size="20px" font-weight="bold">Don't Miss Out!</mj-text>
        <mj-text>
          Hi there, we noticed you were interested in <strong>${selectedProduct.title}</strong>. It's still available, and we wouldn't want you to miss the chance to make it yours.
        </mj-text>
        <mj-text>
          Act now and enjoy the elegance of ${selectedProduct.title} for just <strong>${selectedProduct.variants[0].price}</strong>. Don’t wait too long—our stock is running low!
        </mj-text>
        <mj-button href="https://${domain}/products/${selectedProduct.title}" background-color="#4CAF50" color="#ffffff">
          Buy Now
        </mj-button>
        <mj-text font-size="16px" font-style="italic">
          Need help or have questions? We're here to assist you anytime!
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>

      `);
    }

    // Close the modal
    handleViewProductClose();
  };

  useEffect(() => {
    const fetchProductsandCollection = async () => {
      try {
        const response = await fetch(`${backendUrl}/products-info`);
        const data = await response.json();
        console.log(data);

        setProducts(data.products.products);
        setDomain(data.storeDomain);
        // const response1 = await fetch(`${backendUrl}/collections-info`);
        // const data1 = await response1.json();
        // setCollections(data1);
      } catch (error) {
        console.error("Error fetching products or Collection:", error);
      }
    };
    fetchProductsandCollection();
  }, []);

  const handleProductSelect = (product, isSelected) => {
    let updatedSelectedProductIds = [...selectedProductIds];
    let updatedSelectedVariantIds = [...selectedVariantIds];

    if (isSelected) {
      // Select product if it has no variants
      if (product.variants.length === 0) {
        updatedSelectedProductIds.push(product.id);
      } else {
        // Select all variants if product is selected
        product.variants.forEach((variant) => {
          if (!updatedSelectedVariantIds.includes(variant.id)) {
            updatedSelectedVariantIds.push(variant.id);
          }
        });
        // Also select the product itself
        if (!updatedSelectedProductIds.includes(product.id)) {
          updatedSelectedProductIds.push(product.id);
        }
      }
    } else {
      // Deselect product and all its variants
      updatedSelectedProductIds = updatedSelectedProductIds.filter(
        (id) => id !== product.id
      );

      product.variants.forEach((variant) => {
        updatedSelectedVariantIds = updatedSelectedVariantIds.filter(
          (id) => id !== variant.id
        );
      });
    }

    setSelectedProductIds(updatedSelectedProductIds);
    setSelectedVariantIds(updatedSelectedVariantIds);
  };

  const handleVariantSelect = (product, variantId, isSelected) => {
    let updatedSelectedProductIds = [...selectedProductIds];
    let updatedSelectedVariantIds = [...selectedVariantIds];

    if (isSelected) {
      // Add variant ID to the selected variant IDs
      if (!updatedSelectedVariantIds.includes(variantId)) {
        updatedSelectedVariantIds.push(variantId);
      }

      // Ensure the product is selected if any variant is selected
      if (!updatedSelectedProductIds.includes(product.id)) {
        updatedSelectedProductIds.push(product.id);
      }
    } else {
      // Remove variant ID from the selected variant IDs
      updatedSelectedVariantIds = updatedSelectedVariantIds.filter(
        (id) => id !== variantId
      );

      // If no variants are selected, deselect the product
      const isAnyVariantSelected = product.variants.some((variant) =>
        updatedSelectedVariantIds.includes(variant.id)
      );
      if (!isAnyVariantSelected) {
        updatedSelectedProductIds = updatedSelectedProductIds.filter(
          (id) => id !== product.id
        );
      }
    }

    setSelectedProductIds(updatedSelectedProductIds);
    setSelectedVariantIds(updatedSelectedVariantIds);
  };

  const handleViewProductClose = () => {
    SetViewProduct(false);
  };

  useEffect(() => {
    const editorInstance = grapesjs.init({
      container: "#editor",
      allowScripts: true,
      plugins: [mjmlPlugin],
      pluginsOpts: {
        mjmlPlugin: {
          fromElement: true,
          exclude: ["mj-social-elements", "group-social"],
        },
      },

      components: `
        <mjml>
          <mj-body>
          </mj-body>
        </mjml>
      `,
      storageManager: {
        id: "gjs-",
        autosave: true,
        autoload: true,
        stepsBeforeSave: 1,
        type: "indexeddb",
      },
    });

    const panelManager = editorInstance.Panels;

    panelManager.addButton("options", [
      {
        id: "save",
        className: "fa fa-save",
        command: "custom-save-command",
        attributes: {
          title: "Save",
        },
        onClick: () =>
          handleSaveOrUpdateButtonClick(editorInstance, panelManager, "save"),
      },
    ]);

    panelManager.addButton("options", [
      {
        id: "update",
        className: "fa fa-edit",
        command: "custom-update-command",
        attributes: {
          title: "Update",
        },
        onClick: () =>
          handleSaveOrUpdateButtonClick(editorInstance, panelManager, "update"),
      },
    ]);

    panelManager.addButton("options", [
      {
        id: "link",
        className: "fa fa-link",
        command: "custom-link-command",
        attributes: {
          title: "Link",
        },
        onClick: handleLinkButtonClick,
      },
    ]);

    editorInstance.Commands.add("custom-save-command", {
      run: () => {
        handleSaveOrUpdateButtonClick(editorInstance, panelManager, "save");
      },
    });

    editorInstance.Commands.add("custom-update-command", {
      run: () => {
        handleSaveOrUpdateButtonClick(editorInstance, panelManager, "update");
      },
    });

    editorInstance.Commands.add("custom-link-command", {
      run: handleLinkButtonClick,
    });

    editorInstance.on("component:selected", (model) => {
      console.log("Selected Component:", model.get("name"));
      setLastSelectedComponent(model);
    });

    editorInstance.on("component:click", (model) => {
      const clickedElement = model.view.el;
      const clickedText = model.get("content");

      if (displayTextUrlMap[clickedText]) {
        window.open(displayTextUrlMap[clickedText], "_blank");
      }
    });

    const handleCanvasDrop = (event) => {
      const { editor } = window;

      if (!editor || !editor.Block) {
        console.error("Editor or editor.Block is not defined.");
        return;
      }
    };

    // Add a custom button to fetch DB content
    panelManager.addButton("options", [
      {
        id: "fetch-db-content",
        className: "fa fa-database",
        command: "fetch-db-content-command",
        attributes: {
          title: "Fetch DB Content",
        },
        onClick: () => handleFetchDbContent(editorInstance),
      },
    ]);

    editorInstance.Commands.add("fetch-db-content-command", {
      run: () => handleFetchDbContent(editorInstance),
    });

    const handleFetchDbContent = async (editor) => {
      SetViewProduct(true);
    };

    editorInstance.on("load", () => {
      setEditor(editorInstance);

      const editorContainer = document.getElementById("editor");
      editorContainer.style.overflow = "auto";
      editorContainer.style.height = "100%";
      editorContainer.style.width = "100%";

      if (templateContentFromTheme) {
        editorInstance.DomComponents.clear();
        editorInstance.setComponents(templateContentFromTheme);
      }
    });

    editorInstance.on("canvas:drop", handleCanvasDrop);
    editorInstance.on("canvas:click", handleCanvasClick);

    setEditor(editorInstance);
  }, [templateContentFromTheme]);

  const handleSaveOrUpdateButtonClick = async (
    editorInstance,
    panelManager,
    operation = "save"
  ) => {
    if (!editorInstance) {
      console.error("Editor not initialized yet");
      return;
    }

    // If the operation is "update," show a confirmation message
    if (operation === "update") {
      const confirmation = window.confirm(
        `Are you sure you want to update the template "${templateName}"?`
      );

      if (!confirmation) {
        console.log("Update operation canceled by user.");
        return; // Exit if the user cancels the update
      }
    }

    const mjmlCode = editorInstance.getHtml();
    console.log("MJML Code:", mjmlCode);

    const { html } = mjml2html(mjmlCode);

    console.log("Converted HTML Code:", html);

    let response;

    if (operation === "save") {
      const userTemplateName = prompt(
        `Enter the template name to ${operation}:`
      );
      response = await saveTemplateToBackend(userTemplateName, mjmlCode, html);
    } else if (operation === "update") {
      response = await updateTemplateToBackend(templateName, mjmlCode, html);
    }

    if (response.success) {
      console.log(`Template ${operation}d successfully!`);
      console.log("MJML File URL:", response.mjmlFileUrl);
      console.log("HTML File URL:", response.htmlFileUrl);
    } else {
      console.error(`Failed to ${operation} template:`, response.error);
    }
  };

  const saveTemplateToBackend = async (templateName, mjmlCode, html) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/saveTemplate`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            templateName,
            mjmlCode,
            html,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      return { success: true, result };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const updateTemplateToBackend = async (templateName, mjmlCode, html) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/updateTemplate`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            templateName,
            mjmlCode,
            html,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      return { success: true, result };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const handleCanvasDrop = (event) => {
    const { editor } = window;

    const enteredText = displayText;

    const newComponent = editor.Block.create({
      type: "text",
      content: enteredText,
      style: {
        color: "green",
        "font-size": "16px",
        "text-decoration": "underline",
      },
    });

    editor.DomComponents.addComponent(newComponent);
    resetEmailForm();
  };

  const emailPopupStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "5px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
    zIndex: 1000,
    width: "450px",
    height: "300px",
    maxWidth: "80%",
    overflow: "auto",
  };

  const emailPopupSentenceStyle = {
    color: "#00008B",
    fontWeight: "bold",
    fontSize: "20px",
    marginBottom: "20px",
    textAlign: "center",
  };

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <div className="frontend" style={{ overflowY: "hidden" }}>
        <div
          id="editor"
          className="grapesjs-editor"
          style={{
            position: "absolute",
            left: isMenuOpen ? "3.6%" : "50%",
            width: isMenuOpen ? "20%" : "100%",
          }}
        ></div>

        {currentTemplateName && (
          <div
            className="template-content"
            style={{ overflowY: "hidden", overflowX: "auto" }}
          >
            <h2>{currentTemplateName}</h2>
            <pre>{currentTemplateContent}</pre>
          </div>
        )}

        {emailPopupVisible && (
          <div className="email-popup" style={emailPopupStyle}>
            <form onSubmit={handleEmailPopupSubmit}>
              <div style={emailPopupSentenceStyle}>LINK</div>
              <label style={{ fontWeight: "bold" }}>Display Text</label>
              <input
                type="text"
                value={displayText}
                onChange={(e) => setDisplayText(e.target.value)}
                required
                style={{ marginBottom: "20px", height: "30px", width: "100%" }}
              />
              <br />
              <label style={{ fontWeight: "bold" }}>Link Type</label>
              <input
                type="text"
                value={linkType}
                onChange={(e) => setLinkType(e.target.value)}
                required
                style={{ marginBottom: "20px", height: "30px", width: "100%" }}
              />
              <br />
              <label style={{ fontWeight: "bold" }}>URL</label>
              <input
                type="text"
                value={linkURL}
                onChange={(e) => setLinkURL(e.target.value)}
                required
                style={{ marginBottom: "20px", height: "30px", width: "100%" }}
              />
              <br />
              <button
                type="submit"
                style={{
                  marginRight: "10px",
                  fontSize: "16px",
                  backgroundColor: "green",
                  color: "white",
                }}
              >
                OK
              </button>
              <button
                type="button"
                onClick={() => {
                  setEmailPopupVisible(false);
                  resetEmailForm();
                }}
                style={{ fontSize: "16px" }}
              >
                Close
              </button>
            </form>
          </div>
        )}

        <Modal show={viewProduct} onHide={handleViewProductClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>Products</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Search products"
            />
            <div
              style={{
                maxHeight: "300px",
                overflowY: "auto",
                border: "1px solid #ddd",
                padding: "10px",
              }}
            >
              {products.map((product) => (
                <ProductItem
                  key={product.id}
                  product={product}
                  selectedProductIds={selectedProductIds}
                  selectedVariantIds={selectedVariantIds}
                  onProductSelect={handleProductSelect}
                  onVariantSelect={handleVariantSelect}
                />
              ))}
            </div>
          </Modal.Body>
          <Modal.Footer
            style={{
              height: "60px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button variant="secondary" onClick={handleViewProductClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleViewProductSubmit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default Frontendapp;
